import ButtonComponent from '@/components/ButtonComponent';
import styled from 'styled-components';
import theme from '@/styles/theme';

interface Props {
  cancelReason: string;
  onCloseModal: () => void;
  onSubmitPrescriptionDeny: () => void;
}
const PrescriptionDenyConfirmModal = ({
  cancelReason,
  onCloseModal,
  onSubmitPrescriptionDeny
}: Props) => {
  return (
    <ModalWrapper>
      <ModalTop>
        <Title>조제 거절하시겠습니까?</Title>
        <Content>
          <span>{`거절 사유: ${cancelReason}`}</span>
          {`[확인]을 누르시면 조제가 거절되고\n처방전은 삭제됩니다.`}
        </Content>
      </ModalTop>
      <ModalBottom>
        <ButtonComponent
          borderColor={theme.DF_COLOR.WHITE}
          bgColor={theme.DF_COLOR.WHITE}
          textColor={theme.DF_COLOR.BLACK}
          text={'취소'}
          padding={'1rem'}
          onClick={onCloseModal}
        />
        <ModalButtonDivision />
        <ButtonComponent
          borderColor={theme.DF_COLOR.WHITE}
          bgColor={theme.DF_COLOR.WHITE}
          textColor={theme.DF_COLOR.BLACK}
          text={'확인'}
          padding={'1rem'}
          onClick={onSubmitPrescriptionDeny}
        />
      </ModalBottom>
    </ModalWrapper>
  );
};

export default PrescriptionDenyConfirmModal;

const ModalWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
`;

const ModalTop = styled.div`
  padding: 40px;
  width: 480px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
`;

const Title = styled.div`
  ${({ theme }) => `
    ${theme.DF_TYPOGRAPHY.UI26B};
    color: ${theme.DF_COLOR.GRAY700};
  `};
`;
const Content = styled.div`
  white-space: pre-wrap;
  text-align: center;

  ${({ theme }) => `
    ${theme.DF_TYPOGRAPHY.UI20R};
    color: ${theme.DF_COLOR.GRAY500};

    span {
      display: block;
      color: ${theme.DF_COLOR.PRIMARY600};
    }
  `};
`;

const ModalBottom = styled.div`
  width: 100%;
  text-align: center;
  cursor: pointer;
  display: flex;

  > * {
    &:nth-child(odd) {
      flex: 1;
    }
  }
  ${({ theme }) => `
    border-top: 1px solid ${theme.DF_COLOR.GRAY100};
  `};
`;

const ModalButtonDivision = styled.div`
  width: 1px;
  margin: 0 1px;
  ${({ theme }) => `
    background: ${theme.DF_COLOR.GRAY100};
  `};
`;
